import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { TemplatesState } from './types';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: TemplatesState = {
    pushTemplates: null,
};


export const pushTemplate: Module<TemplatesState,RootState> = {
    state,
    getters,
    actions,
    mutations
};
